export const educationFormatOptions = t => [
  { value: "fullTime", label: t("eduInfo.fullTime") },
  { value: "partTime", label: t("eduInfo.partTime") },
]
